<template>
  <div>
    <li class="evenStyle">****** &nbsp;&nbsp;<span class="changeStyle pointer" style="color:#0a81e5;width:30px;" @click="changePassword">修改密码</span></li>
    <mu-dialog :open="showPass" title="修改密码" scrollable dialogClass='password-dialog' @show='onDialogShow'>
      <mu-row>
        <mu-flexbox orient="vertical">
          <mu-flexbox-item>
            <mu-text-field
              label="原密码"
              v-model="oldPass"
              type="password"
              :errorText="orignPasswordError"
              hintText="请输入原密码"
              @input = 'validateFormModals'
              name="原密码"
            />
          </mu-flexbox-item>
          <mu-flexbox-item>
            <mu-text-field label="新密码"
              v-model="newPass"
              type="password"
              :errorText="newPasswordError"
              hintText="请输入新密码"
              @input = 'validateFormModals'
              name="新密码"
            />
          </mu-flexbox-item>
          <mu-flexbox-item>
            <mu-text-field
              label="确认密码"
              v-model="confirmPass"
              type="password"
              :errorText="confirmPasswordError"
              hintText="请再次输入新密码"
              @input = 'validateFormModals'
              name="确认密码"
            />
          </mu-flexbox-item>
        </mu-flexbox>
      </mu-row>
      <div
        slot = 'actions'
      >
        <mu-raised-button label="取消" @click="cancelChangePassword" class="btn-style" style="color:#999;margin-left:20px;"/>
        <mu-raised-button
          label="提交"
          @click="submitData"
          class="btn-style"
          primary
          :disabled = 'allowSubmit === false'
          />
      </div>
    </mu-dialog>
    <mu-popup position="top" :overlay="false" popupClass="demo-popup-top" :open="topPopup">
      密码修改成功
    </mu-popup>
  </div>
</template>
<script>
  import Vue from 'vue'

  export default ({
    props: ['username'],
    data() {
      return {
        showPass: false,
        topPopup: false,
        oldPass: '',
        newPass: '',
        confirmPass: '',
        errorOld: '',
        errorNew: '',
        orignPasswordError: '',
        newPasswordError: '',
        confirmPasswordError: '',
        allowSubmit: false,
        passFormat: new RegExp(/^[a-zA-Z0-9]*([a-zA-Z][0-9]|[0-9][a-zA-Z])[a-zA-Z0-9]*$/), //密码正则
      }
    },
    computed:{
      oldPError: function(){
        if(this.errorOld){
          return this.errorOld;
        } else {
          return this.errors.first('原密码');
        }
      },
      newPError: function(){
        if(this.errorNew){
          return this.errorNew;
        } else {
          return this.errors.first('新密码');
        }
      },
    },
    watch: {
      topPopup (val) {
        if (val) {
          setTimeout(() => {
            this.topPopup = false
          }, 2000)
        }
      }
    },
    mounted: function ()
    {
    },
    methods: {
      validateFormModals: function (ev)
      {
        let ret = true;
        if (this.oldPass.length === 0)
        {
          this.orignPasswordError = '请填写旧密码';
          ret = false;
        }
        else
        {
          this.orignPasswordError = '';
        }
        if (this.newPass.length === 0)
        {
          this.newPasswordError = '请填写新密码';
          ret = false;
        }
        else if (!this.passFormat.test(this.newPass)){
          this.newPasswordError = '新密码必须为字母和数字的组合';
          ret = false;
        }
        else if(this.newPass.length < 6 || this.newPass.length >16){
          this.newPasswordError = '新密码位数为6-16位';
          ret = false;
        }
        else if(this.newPass === this.oldPass)
        {
          this.newPasswordError = '新旧密码不能相同';
          ret = false;
        }
        else
        {
          this.newPasswordError = '';
        }
        if (this.confirmPass.length>0 && this.confirmPass !== this.newPass)
        {
          this.confirmPasswordError = '两次填写密码不一致';
          ret = false;
        }
        else
        {
          this.confirmPasswordError = '';
        }
        this.allowSubmit = ret;
        return ret;
      },
      onDialogShow: function(ev)
      {
        try
        {
          let dialogDiv = $('div.password-dialog');
          dialogDiv.css('min-height', dialogDiv.height());
        }
        catch(ex)
        {
          console.log(ex);
        }
      },
      changePassword: function(){
        this.showPass = true;
      },
      cancelChangePassword: function()
      {
        this.showPass = false;
        this.errorOld = '';
        this.errorNew = '';
        this.newPass = '';
        this.oldPass = '';
        this.confirmPass = '';
      },
      submitData: function(){
        var self = this;
        self.$http.post('/api/Auth/resetPersonalPassword',{
          username: self.username,
          old_password:self.oldPass,
          new_password:self.newPass,
          confirm_passord: self.confirmPass
        },{emulateJSON: true})
        .then(
          function(res)
          {
            self.showPass = false;
            self.topPopup = true;
            self.errorOld = '';
            self.errorNew = '';
            self.oldPass = '';
            self.newPass = '';
            self.confirmPass = '';
          },
          function(req)
          {
            self.errorOld = '';
            self.errorNew = '';
            if(req.body.resultMsg.indexOf('密码')>=0){
              self.orignPasswordError = req.body.resultMsg;
            }
          }
        );

        return;
        this.$validator.validateAll()
          .then(function(isValid) {
            if(false == isValid){
              return false;
            }
            self.$http.post('/api/Auth/resetPersonalPassword',{
              username: self.username,
              old_password:self.oldPass,
              new_password:self.newPass,
              confirm_passord: self.confirmPass
            },{emulateJSON: true})
            .then(
              function(res){
                self.showPass = false;
                self.topPopup = true;
                self.errorOld = '';
                self.errorNew = '';
                self.oldPass = '';
                self.newPass = '';
                self.confirmPass = '';
              },
              function(req){
                self.errorOld = '';
                self.errorNew = '';
                if(req.body.resultMsg.indexOf('密码')>=0){
                  self.orignPasswordError = req.body.resultMsg;
                }
              }
            )
          })
      }
    }
  })
</script>
<style>
  .demo-popup-top {
    width: 100%;
    opacity: 0.8;
    height: 48px;
    line-height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 375px;
  }
  .password-dialog {
    background: #FFF;
  }
</style>



// WEBPACK FOOTER //
// passChange.vue?14b06d8a